import { connect } from 'react-redux'
import NotificationsPage from '@components/notifications/NotificationsPage'

export default connect(undefined, undefined)(NotificationsPage)
